import { Alert, Skeleton, Stack } from "@tm/components"
import { CompilationModel } from "@tm/data/compilations"
import { isWM } from "@bundles/compilations/utils"
import { EmptyCompilation } from "@bundles/compilations/components/EmptyCompilation"
import { ExpandedCompilationsList } from "./ExpandedCompilationsList"
import { CompactCompilationsList } from "./CompactCompilationsList"
import { useFavoriteArticlesStore } from "../store"

type CompilationListProps = {
    compilations: CompilationModel[] | undefined
    loading: boolean
    error: string | null
    compilationId?: string
    onOpenDetails(id: string): void
    onCloseDetails(): void
}

export function CompilationList({ compilations, loading, error, compilationId, onOpenDetails, onCloseDetails }: CompilationListProps) {
    const { query } = useFavoriteArticlesStore()

    function renderList(items: CompilationModel[]) {
        if (isWM() || !compilationId) {
            return <ExpandedCompilationsList compilations={items} onOpenCompilationDetails={onOpenDetails} />
        }

        return (
            <CompactCompilationsList
                compilations={items}
                onOpenCompilationDetails={onOpenDetails}
                openCompilationList={onCloseDetails}
                query={query}
            />
        )
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>
    }

    if (isWM() && !!compilationId) {
        return null
    }

    if (loading) {
        return (
            <Stack flex={compilationId ? undefined : 1} width="310px" pt={2}>
                <Skeleton variant="text" height="30px" />
                <Skeleton variant="text" height="63px" />
                <Skeleton variant="text" height="63px" />
            </Stack>
        )
    }

    return (
        <Stack flex={compilationId ? undefined : 1} width="310px">
            {!compilations || compilations.length === 0 ? <EmptyCompilation /> : renderList(compilations)}
        </Stack>
    )
}
